import React from 'react';
import Icon from '../../../components/AppIcon';

const EarningsSummary = ({ deals, currentLanguage }) => {
  const translations = {
    en: {
      earnings: 'Earnings Summary',
      potentialIncome: 'Potential Income',
      completedDeliveries: 'Completed Deliveries',
      activeDeals: 'Active Deals',
      rating: 'Your Rating'
    },
    ko: {
      earnings: '수익 요약',
      potentialIncome: '예상 수익',
      completedDeliveries: '완료된 배송',
      activeDeals: '활성 거래',
      rating: '내 평점'
    }
  };

  const t = translations?.[currentLanguage];

  const completedDeals = deals?.filter(d => d?.status === 'completed') || [];
  const activeDeals = deals?.filter(d => ['accepted', 'in_transit', 'delivered']?.includes(d?.status)) || [];
  
  const potentialIncome = activeDeals?.reduce((sum, deal) => sum + (deal?.request?.carrierFee || 0), 0);
  const completedCount = completedDeals?.length;
  const activeCount = activeDeals?.length;

  const formatCurrency = (amount) => {
    return `${amount?.toLocaleString()}원`;
  };

  const stats = [
    {
      label: t?.potentialIncome,
      value: formatCurrency(potentialIncome),
      icon: 'DollarSign',
      color: 'var(--color-success)',
      bg: 'bg-success/10'
    },
    {
      label: t?.completedDeliveries,
      value: completedCount?.toString(),
      icon: 'CheckCircle',
      color: 'var(--color-primary)',
      bg: 'bg-primary/10'
    },
    {
      label: t?.activeDeals,
      value: activeCount?.toString(),
      icon: 'TrendingUp',
      color: 'var(--color-warning)',
      bg: 'bg-warning/10'
    }
  ];

  return (
    <div className="bg-card rounded-lg shadow-elevation-md overflow-hidden">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 md:w-12 md:h-12 bg-success/10 rounded-lg flex items-center justify-center">
            <Icon name="Wallet" size={24} color="var(--color-success)" />
          </div>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-semibold text-foreground">
            {t?.earnings}
          </h2>
        </div>
      </div>
      <div className="p-4 md:p-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {stats?.map((stat, index) => (
            <div key={index} className="flex items-center gap-3 p-4 bg-muted/30 rounded-lg">
              <div className={`w-12 h-12 ${stat?.bg} rounded-lg flex items-center justify-center flex-shrink-0`}>
                <Icon name={stat?.icon} size={20} color={stat?.color} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-muted-foreground caption mb-1">{stat?.label}</p>
                <p className="text-lg md:text-xl font-semibold text-foreground data-text truncate">
                  {stat?.value}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EarningsSummary;